import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { useStateValue } from './StateProvider';

//css
import './Subtotal.css';

function Subtotal() {


    const [{ basket }, dispatch] = useStateValue();
    console.log("subtotal", basket);
    const totalItems = basket.reduce((acc, curr) => curr.qty + acc, 0);

    const total = basket.reduce((acc, curr) => (curr.qty * curr.oprice) + acc, 0);
    console.log(total);


    return (
        <div className="subtotal">

            <CurrencyFormat
                renderText={value => (
                    <>
                        <div className="subtotal__menu"> Total Items: {totalItems}</div>
                        <div className="subtotal__menu">Total Cost:  {value}</div>
                        <div className="subtotal__menu">Shipping Fee: {0}</div>
                        <div className="subtotal__menu">actual Cost: {value} </div>
                        <div className="subtotal__menu">
                            <button className="subtotal__paybutton">Pay Now</button>
                        </div>

                    </>


                )}
                decimalScale={2}
                value={total}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"₹"}
            />

        </div>
    )
}

export default Subtotal
